export const UrlHelper = (
	path: string,
	params: Record<string, string | string[] | number | boolean | undefined | null> = {},
) => {
	// https://github.com/microsoft/TypeScript/issues/16655
	const q = Object.entries(params)
		.map(([k, v]) => ((v !== '' && !!v) || v === false ? [k, v.toString()] : undefined))
		.filter((v): v is string[] => !!v);

	const qs = new URLSearchParams(q).toString();
	return `${path}${qs ? `?${qs}` : ''}`;
};
